<template>
  <template v-for="carousel in carousels" :key="carousel.title">
    <section v-if="isPending || carousel.articles.length" class="mb-72">
      <RevSkeleton
        v-if="isPending"
        height="344px"
        shape="rectangle"
        width="100%"
      />
      <ArticleCardsCarousel
        v-else-if="carousel.articles.length > 0"
        :articles="carousel.articles"
        :title="carousel.title"
      />
    </section>
  </template>
</template>

<script setup lang="ts">
import type { ArticleCard } from '@backmarket/nuxt-layer-cms/ArticleCard/ArticleCard.types'
import ArticleCardsCarousel from '@backmarket/nuxt-layer-cms/ArticleCard/ArticleCardsCarousel.vue'
import { RevSkeleton } from '@ds/components/Skeleton'

defineProps<{
  carousels: Array<{ title: string; articles: ArticleCard[] }>
  isPending: boolean
}>()
</script>
